import React, { lazy, useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const Login = lazy(() => import('../pages/Authentication/Login'));
const SignUp = lazy(() => import('../pages/Authentication/SignUp'));
const Verification = lazy(() => import('../pages/Authentication/Verification'));
const ForgotPassword = lazy(() => import('../pages/Authentication/ForgotPassword'));

const PublicRoutes = () => {
    const [currentEmail, setCurrentEmail] = useState('');
    const [currentPassCode, setCurrentPassCode] = useState('');

    return (
        <Routes>
            <Route path="login" element={<Login setCurrentEmail={setCurrentEmail} />} />
            <Route
                path="signup"
                element={
                    <SignUp
                        setCurrentEmail={setCurrentEmail}
                        setCurrentPassCode={setCurrentPassCode}
                    />
                }
            />
            <Route
                path="verification"
                element={
                    <Verification currentEmail={currentEmail} currentPassCode={currentPassCode} />
                }
            />
            <Route
                path="forgot_password"
                element={
                    <ForgotPassword currentEmail={currentEmail} setCurrentEmail={setCurrentEmail} />
                }
            />

            <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
    );
};

export default PublicRoutes;
